module.exports = __webpack_public_path__ + "static/3-dog-greenery-d39cd9efba5568668bf2be5a7b3edcb0.png";